import { Box, Divider, Stack, Typography } from '@mui/material';
import { ButtonComponent } from 'components/ButtonComponent';
import { fieldType } from 'components/FormCreator/types';
import FormCreatorComponent from 'components/FormCreatorComponent';
import CheckBox from 'components/FormCreatorComponent/inputs/CheckBox';
import { createFormProps } from 'components/FormCreatorComponent/types';
import { withdrawalBalanceSteps } from 'constants/customer-account.constants';
import { SupportType } from 'constants/requests.constants';
import { pagesEnum } from 'constants/ui.constants';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import _ from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { withdrawalBalanceTypesForms } from 'sections/CustomerAccounts/forms.types';
import { getWithdrawalFormsValuesByTypeAndStep } from 'sections/CustomerAccounts/helper';
import { verifyCloseAccount } from 'services/customer-accounts.service';
import { transferDetailsFinalCustomerBankAccount } from 'services/pending-requests.service';
import { getCompanyDashboard } from 'state/reducers/customer-accounts.reducers';
import { selectTranslations } from 'state/reducers/translation.reducers';

interface IWithdrawBalanceStep3Props {
	balanceRequest: any;
	withdrawalBalanceForm: createFormProps;
	supportRequest: any;
	handleNavigateToCompanyPage: any;
}

export const WithdrawBalanceStep3 = (props: IWithdrawBalanceStep3Props) => {
	const { balanceRequest, withdrawalBalanceForm, supportRequest, handleNavigateToCompanyPage } = props;
	const t = useAppSelector(selectTranslations);
	const dispatch = useAppDispatch();
	const companyData = useAppSelector(getCompanyDashboard);
	const [formValues, setFormValues] = useState<Record<string, any>>({});
	const [formState, setFormState] = useState<Record<string, any>>({});
	const isContinueDisabled = useMemo(() => !formState.isValid, [formState]);
	const navigate = useNavigate();
	useEffect(() => {
		if (!_.isEmpty(balanceRequest)) {
			const pickFormValues = getWithdrawalFormsValuesByTypeAndStep(
				balanceRequest,
				withdrawalBalanceSteps.WITHDRAWAL_ALTSHULER_TO_CUSTOMER_BANK_ACCOUNT
			);
			setFormValues(pickFormValues);
		}
	}, [balanceRequest]);

	useEffect(() => {
		if (formState?.values) setFormValues(formState?.values);
	}, [formState]);

	const handleFinalApprove = () => {
		dispatch(
			transferDetailsFinalCustomerBankAccount({
				balanceRequestId: balanceRequest.id,
				currencyId: formValues.final_altshuler_transfer_currency_id,
				amount: formValues.final_altshuler_account_transfer_amount,
				altshulerAccountId: formValues.final_altshuler_transfer_account_id,
				customerBankAccountId: formValues.customer_account_id,
				reference: formValues.reference,
				file: formValues.transfer_file,
			})
		).then((val) => {
			if (val) {
				handleNavigateToCompanyPage();
			}
		});
	};
	return (
		<Box marginTop="40px" maxWidth="664px" paddingLeft="96px">
			{!_.isEmpty(formValues) && withdrawalBalanceForm && (
				<>
					<FormCreatorComponent
						{...withdrawalBalanceForm}
						translation={t}
						values={formValues}
						handleChange={(formState: Record<string, any>) => {
							setFormState(formState);
						}}
					/>
					<Divider sx={{ marginTop: '68px', marginBottom: '20px' }} />
					<Box sx={{ width: '100%', display: 'flex', justifyContent: 'end', marginTop: '48px' }}>
						<ButtonComponent
							styleObj={{ marginLeft: '24px' }}
							disabled={isContinueDisabled}
							text={t(
								`page.withdrawal.forms.${_.snakeCase(
									withdrawalBalanceSteps.WITHDRAWAL_ALTSHULER_TO_CUSTOMER_BANK_ACCOUNT
								)}.continue_button`
							)}
							handleClick={() => handleFinalApprove()}
						/>
					</Box>
				</>
			)}
		</Box>
	);
};
